// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"dc131298","107":"9c86c20e","229":"77c0cda0","253":"ab43b362","402":"8582f071","457":"2a7c6fe6","464":"f0d07c48","679":"7e756035","716":"43de1fd0"}[chunkId] + ".chunk.js";
};